module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-rj.cb265f82.jpg";